var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"border":"none","padding-bottom":"96px"},attrs:{"src":_vm.computedFrameUrl,"width":"900","height":"1300"}})}
var staticRenderFns = []

export { render, staticRenderFns }